exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ml50[data-v-35be930c] {\n  margin-left: -50px;\n}\n.mt6-l[data-v-35be930c] {\n  margin-top: 12rem;\n}\n.min-w7[data-v-35be930c] {\n  min-width: 40rem;\n}\n", ""]);

// exports
